import type { UserState } from '../types';

export const INIT_STATE: UserState = {
  loading: false,
  settingsLoading: false,
  error: null,
  data: undefined,
  access_role_id: undefined,
  adsActivityConfig: { newActivityTable: false },
};
